import { LenderClientsManagementApi } from '@sg/api/lender-clients-management-api';
import { Observable } from 'rxjs';

export const LenderLeadSessionInjectionToken = 'LenderLeadSession';

export interface LenderLeadSession {
  isFinishedLoading$: Observable<'init' | 'ready' | 'error'>;
  lenderLegalEntityDetails: LenderClientsManagementApi.LegalEntityBaseDto;
}
